import type { FindFn } from "@shared/models/analytics/base"

export default function (_payload, findFn: FindFn, userId: string, planbookId: string) {
  return {
    planbook: findFn("planbook", planbookId),
    user: findFn("user", userId),
  }
}
